var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ob1-cards", { attrs: { "additional-classes": "full-height" } }, [
    _c(
      "div",
      {
        staticClass:
          "p-1 text-center h-100 d-flex flex-column align-items-stretch justify-content-between",
      },
      [
        _c("div", [
          _vm.title
            ? _c("div", {
                staticClass: "h3 mb-0 mobile-infos navads",
                domProps: { innerHTML: _vm._s(_vm.title) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.text
            ? _c("p", {
                staticClass:
                  "lead mb-0 infos-price navads mt--1 text-gray3 fw-bold",
                domProps: { innerHTML: _vm._s(_vm.text) },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-1 infos-advantage navads" }, [
          _c(
            "div",
            { staticClass: "img-container" },
            [
              _vm.visual
                ? _c("ob1-picture", { attrs: { visual: _vm.visual } })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "infos-seller navads" }),
        _vm._v(" "),
        _vm.url !== undefined && _vm.urlAccessWording !== undefined
          ? _c("ob1-boutons", {
              staticClass: "pb-1 mx-auto",
              attrs: {
                "is-secondary": true,
                "is-button": false,
                label: _vm.urlAccessWording,
                href: _vm.url,
                target: "_blank",
              },
              on: { "ob1-boutons-click": _vm.sendTmsForNavads },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }